import { CoreInterfaces, DTOs } from "src/core/Models";

export const StartUpAccountingProcessor: CoreInterfaces.QuestionProcessors = (
  appState: CoreInterfaces.AppState,
  serviceDTO: DTOs.ServiceDTO
) => {
  return {};
};
